/* eslint-disable @typescript-eslint/no-explicit-any */
import AbstractFormControl from './AbstractFormControl';
import ControlValidator from './validator/CustomValidator';

class FormControl<T = any> extends AbstractFormControl<T> {
  constructor(
    initialValue: T,
    public readonly validators: ControlValidator<T>[] = [],
  ) {
    super(initialValue, validators);
    this.runValidators();
  }
}

export default FormControl;
